import { Api } from 'models/services/api';
import { CreateCompanyQuery } from 'models/services/graphql';

import { CompanyData, CompanyDataToSave } from '../index';

type DataToCreate = {
  input: CompanyDataToSave;
};

const RequestQuery = `
  mutation CreateCompany($input: CompanyInput!) {
    ${CreateCompanyQuery}
  }
`;

type ResponseData = {
  data: {
    createCompany: CompanyData
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly document?: CompanyData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.createCompany;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { CreateGql };